export default {"src":"/_next/static/media/flipkart.f8d91ce9.svg","height":118,"width":267,"blurWidth":0,"blurHeight":0};